// Rails renders window.DOMAIN_NAME per request (layouts/client_configs/_domain_name.js.erb).
// Prefer it over process.env.DOMAIN_NAME, which webpack inlines at build time: on a Heroku
// review app the slug is built with the parent app's config, so the baked-in value points at
// staging and every request leaves the review app.
function domainName () {
  if (typeof window !== 'undefined') return window.DOMAIN_NAME || window.location.origin
  return process && process.env && process.env.DOMAIN_NAME
}

export default function buildUrl (path) {
  const domain = domainName()
  if (!domain) return
  if (domain.startsWith('http')) {
    return domain + path
  } else {
    return 'https://' + domain + path
  }
}
